import { SVGProps } from 'react';

const Undo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 13H3V7m0 6 3-2.7A9 9 0 0 1 12 8a9 9 0 0 1 9 9"
    />
  </svg>
);
export default Undo;
